import React from "react";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { BrowserRouter, Route, Routes, Link } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Home from "./home";
import Connect from "./connect";
import { content } from "./content";
import Article from "./article";
import Articles from "./articles";
import HireMe from "./hireme";
import Situation from "./Situation";
import AboutMe from "./aboutme";

import "./custom.scss";

function App({ router: Router = BrowserRouter }) {
  return (
    <HelmetProvider>
      <Router>
        <div className="montserrat-rpm">
        <Navbar bg="dark" expand="md" sticky="top" className="navbar-dark">
          <Navbar.Brand as={Link} to="/">
            <img
              src="/logo/rick_bridge.svg"
              alt="Rick Molenaar"
              height="30"
              className="navbar-logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/hireme" data-testid="hireMeMenu">
                Hire Me
              </Nav.Link>
              <NavDropdown
                title="My Thoughts"
                id="articlesDropDownMenu"
                data-testid="articlesDropDownMenu"
                show={process.env.NODE_ENV === 'test' ? true : undefined}
              >
                <NavDropdown.Item
                  as={Link}
                  to="/articles"
                  key="articleDropDownItem_summary"
                  data-testid="articleDropDownItem_summary"
                >
                  Summaries
                </NavDropdown.Item>
                <NavDropdown.Divider />
                {content.articles.map((article, index) => (
                  <NavDropdown.Item
                    as={Link}
                    to={"/articles/" + article.link}
                    key={"articleDropDownItem_" + index}
                    data-testid={"articleDropDownItem_" + index}
                  >
                    {article.title}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>
              <Nav.Link as={Link} to="/aboutme" data-testid="aboutmeMenu">
                About Me
              </Nav.Link>
              <Nav.Link as={Link} to="/connect" data-testid="connectMenu">
                Connect
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="hireme" element={<HireMe />} />
          <Route path="hireme/:id" element={<Situation />} />
          <Route path="articles" element={<Articles />} />
          <Route path="articles/:id" element={<Article />} />
          <Route path="aboutme" element={<AboutMe />} />
          <Route path="connect" element={<Connect />} />
        </Routes>
      </div>
    </Router>
    </HelmetProvider>
  );
}

export default App;
